import { FLAG } from '@shared/products-types';

import type { Dashboard } from '../../types/Dashboard';

export const dashboardATFeatureConfig: Dashboard = {
    hidePerformanceForFlags: [FLAG.trueWealthAccount],
    hideSettingsForFlags: [],
};
